import $ from 'jquery';

const blockSpacer = () => {
  const spacer = $('.wp-block-spacer');

  if (spacer.length) {
    $.each(spacer, (i, el) => {
      const self = $(el);
      const height = self.css('height').replace(/px/g, '');

      if (height > 140) {
        self.addClass('is-spacer--70');
      } else if (height > 90) {
        self.addClass('is-spacer--50');
      } else if (height > 50) {
        self.addClass('is-spacer--30');
      } else if (height > 20) {
        self.addClass('is-spacer--20');
      }
    });
  }
};

export default blockSpacer();



// WEBPACK FOOTER //
// ./src/scripts/modules/block-spacer.js